export const projectManifests = [
    {
        "name": "Ouroboros",
        "tagline": "N-dimensional snake.",
        "fullDescription": "Play n-dimensional snake yourself or watch an AI trained to beat it.",
        "icons": [
            "react",
            "python"
        ],
        "files": []
    },
    {
        "name": "Phonefolio",
        "tagline": "A portfolio you can call.",
        "fullDescription": "An AI portfolio assistant, available over the phone. They can control a website.",
        "icons": [
            "react",
            "python"
        ],
        "files": [
            {
                "name": "phoneNumber.png",
                "path": "/Projects/Phonefolio/phoneNumber.png"
            }
        ]
    }
];

export default projectManifests;